import { sectionTitleSlide } from '../../../../slides/shared/section-title-slide';

export const footTrafficTitleSlide = sectionTitleSlide('Visit Attribution');
